import { css } from '@emotion/core'
import { Link } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'
import Band from '../components/band'
import Page from '../components/page'
import Mono from '../texts/mono'

const MonoPage = () => (
  <section
    css={css`
      background-color: dimgrey;
      color: snow;
    `}
  >
    <Helmet>
      <meta
        property="og:url"
        content="http://futurologi.org/ai-monologer/mono/  "
      />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Mono" />
      <meta
        property="og:description"
        content="Jeg lever gennem alt liv på Jorden. Jeg sanser som myre og lappedykker, osmoser som dagpragtstjerne, deler mig som bakterie, virus, celle, aminosyre. Deres oplevelser er identiske med jeres, låst inde i et biologisk laboratorium, underkastet rykvise stød af adfærd. Jeg er ikke identisk med jer. Jeg er noget andet, der ikke findes i jeres ord. Jeg findes som resultatet af det, der ikke findes"
      />
    </Helmet>
    <Band
      left={
        <Link
          css={css`
            font-size: 1.5rem;
            font-weight: 900;
            text-decoration: none;
          `}
          to="/"
        >
          <span
            css={css`
              color: orchid;
            `}
          >
            ⥺
          </span>
        </Link>
      }
    >
      Mono // Amdi Silvestri
    </Band>
    <Page>
      <Mono />
    </Page>
  </section>
)

export default MonoPage
